import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import UserProfile from '../components/UserProfile'
import { __ } from '../services/translate'

class Profile extends Component {
  render() {
    return (
      <Fragment>
        <h1>{__('Profil')}</h1>
        <UserProfile {...this.props}/>
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  language: state.locale.languages.find(lang => lang.id === state.user.language)
})

export default connect(mapStateToProps)(Profile)
